<template>
  <div class="dictindex">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>知识列表</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/maintenance/create')"
          >创建知识</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <el-col :span="6">
          <el-input
            placeholder="请输入标题"
            v-model="dictTypeValue"
            clearable
            class="input-with-select"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="dictSearch"
            ></el-button>
          </el-input>
        </el-col>
        <el-col :span="5">
          <el-select
            v-model="radioStatus"
            placeholder="是否来自公众号"
            @change="radioChange"
            clearable
          >
            <el-option
              v-for="item in radioOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <TzTable
        :tableData="dictList"
        :columns="columns"
        @uploadClick="uploadClick"
        @uploadFn="uploadFn"
      />
      <!-- 表格 -->

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <Edit
      :state="editState"
      @close="editState = false"
      :row="editUnit"
      @confirm="changeDict"
    />
    <!-- 编辑弹框 end -->
  </div>
</template>

<script>
import {
  pageList,
  deleteById,
  updateById,
  updateStatus,
  uploadFile,
  uploadUrl
} from '@/api/maintenance'
import TzTable from '@/components/tz-table/Index.vue'
import Edit from './components/Edit'
export default {
  components: {
    TzTable,
    Edit
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      dictTypeValue: '',
      editState: false,
      radioStatus: null, // 1是;2否
      radioOptions: [
        { value: 1, label: '是' },
        { value: 2, label: '否' }
      ],
      editUnit: {},
      dictList: [],
      columns: [
        {
          field: 'title',
          title: '标题'
        },
        // {
        //   title: '内容',
        //   type: 'richText',
        //   payload: {
        //     field: 'content'
        //   }
        // },
        {
          title: '缩略图',
          width: 140,
          type: 'photoPreview',
          payload: {
            field: 'thumbnail'
          }
        },
        {
          title: '缩略图上传',
          type: 'upload'
        },
        {
          title: '是否来自公众号',
          type: 'switch',
          disabled: true,
          payload: {
            field: 'ispushMp'
          }
        },
        {
          title: '公众号地址',
          type: 'richText',
          payload: {
            field: 'mpUrl'
          }
        },
        {
          title: '状态',
          type: 'switch',
          payload: {
            field: 'deactive',
            change: (row) => this.changeUnitState(row)
          }
        },
        {
          title: '操作',
          width: '160',
          type: 'btn',
          payload: [
            {
              name: '编辑',
              type: 'primary',
              click: (row) => {
                console.log('编辑', row)
                this.editUnit = JSON.parse(JSON.stringify(row))
                // 显示弹框
                this.editState = true
              }
            },
            {
              name: '删除',
              type: 'danger',
              click: (row) => {
                console.log('删除', row)
                this.deleteFn(row)
              }
            }
          ]
        }
      ]
    }
  },
  methods: {
    handleSizeChange(val) {
      this.size = val
      this.getDictList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getDictList()
    },
    // 列表
    getDictList() {
      this.$loading({
        text: '查询中'
      })
      let dictparams = {
        pushMp: this.radioStatus,
        title: this.dictTypeValue,
        pageSize: this.size,
        pageNum: this.page
      }
      pageList(dictparams).then((res) => {
        if (res.code == 200) {
          this.$loading().close()

          let dictArr = res.data.records
          this.total = res.data.total
          this.dictList = dictArr.map((item) => {
            return {
              id: item.id,
              title: item.title,
              content: item.content,
              thumbnail: item.thumbnail,
              status: item.status,
              mpUrl: item.mpUrl,
              deactive: Number(item.status) === 1 ? true : false,
              ispushMp: Number(item.pushMp) === 1 ? true : false
            }
          })
        } else {
          this.$loading().close()
        }
      })
    },
    // 编辑
    changeDict(infos) {
      console.log(infos)
      this.$loading({
        text: '信息更新中'
      })
      let updateparams = {
        // ...infos,
        id: infos.id,
        title: infos.title,
        content: infos.content,
        thumbnail: infos.thumbnail,
        mpUrl: infos.mpUrl,
        status: infos.status
      }
      updateById(updateparams).then((res) => {
        console.log(res.data, '更新')
        this.$loading().close()
        if (res.code == 200) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getDictList()
        } else {
          this.$message({
            type: 'error',
            message: '更新失败!'
          })
        }
        this.editState = false
      })
      setTimeout(() => {
        this.$loading().close()
      }, 1000)
    },
    // 删除
    deleteFn(row) {
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            id: row.id
          }
          deleteById(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getDictList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 状态改变
    changeUnitState(infos) {
      console.log(infos)
      let updateStatusparams = {
        // ...infos,
        id: infos.id,
        status: infos.deactive ? '1' : '0'
      }
      console.log(updateStatusparams)

      updateStatus(updateStatusparams).then((res) => {
        console.log(res.data, '更新')
        // this.$loading().close()
        if (res.code == 200) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getFlieList()
        } else {
          this.$message({
            type: 'error',
            message: '更新失败!'
          })
        }
      })
    },
    // 缩略图上传
    // 点击上传拿到当前行id
    uploadClick(row) {
      console.log(row, '=======================')
      this.rowId = row.id
    },
    uploadFn(parma) {
      let that = this
      console.log(parma, that.rowId, '-----------------')
      const formData = new FormData()
      formData.append('multipartFile', parma.file) // 传入bpmn文件
      that.$loading({
        text: '文件上传中'
      })
      // 上传
      uploadFile(formData).then((res) => {
        console.log(res.data, '上传')
        if (res.code == 200) {
          let params = {
            id: that.rowId,
            thumbnail: res.data.uploadUrl
          }
          // 修改
          uploadUrl(params).then((res) => {
            if (res.code == 200) {
              that.$message({
                message: '上传成功',
                type: 'success'
              })
              setTimeout(() => {
                that.getDictList()
              }, 800)
            } else {
              that.$message({
                type: 'error',
                message: '上传失败!'
              })
            }
          })
        } else {
          that.$message({
            type: 'error',
            message: '上传失败!'
          })
        }
      })
      setTimeout(() => {
        that.$loading().close()
      }, 1500)
    },
    // 模糊查询
    dictSearch() {
      this.page = 1
      this.getDictList()
    },
    // radio选择
    radioChange(el) {
      console.log(el, '当前选择')
      this.page = 1
      this.radioStatus = el
      this.getDictList()
    }
  },
  mounted() {
    this.getDictList()
  }
}
</script>

<style></style>
